// Copyright 2026. WebPros International GmbH. All rights reserved.

import * as React from 'react';
import { connect } from 'react-redux';
import { RootState } from 'admin/core/store';
import {
    Item,
    Translate,
} from '@plesk/ui-library';
import { DashboardItemContainer } from 'admin/dashboard/containers/items/Styles';
import CardHeader from 'admin/dashboard/components/CardHeader';
import StatusesList from 'common/components/StatusesList/StatusesList';
import { StatusType } from 'common/components/Status/Status';

const FAILOVER_DOMAINS_PATH = '/admin/failover_domains';

export type FailoverDomainItemProps =
    ReturnType<typeof mapStateToProps>;

export const FailoverDomainItem: React.FC<FailoverDomainItemProps> = ({
    stats,
}) => (
    <DashboardItemContainer>
        <Item
            view="card"
            title={
                <CardHeader to={FAILOVER_DOMAINS_PATH}>
                    <Translate content="dashboard.cards.failoverDomains" params={{ total: stats.total }} />
                </CardHeader>
            }
        >
            <StatusesList
                items={[
                    {
                        status: StatusType.SUCCESS,
                        labelKey: 'dashboard.failoverDomains.active',
                        value: stats.active,
                        to: `${FAILOVER_DOMAINS_PATH}?is_active=1`,
                    },
                    {
                        status: StatusType.PAUSED,
                        labelKey: 'dashboard.failoverDomains.notActive',
                        value: stats.not_active,
                        to: `${FAILOVER_DOMAINS_PATH}?is_active=0`,
                    },
                ]}
            />
        </Item>
    </DashboardItemContainer>
);

const mapStateToProps = (state: RootState) => ({
    stats: state.dashboard.data.failover_domains,
});

export default connect(mapStateToProps)(FailoverDomainItem);
